<template>
  <li class="dropdown notification-list">
    <div class="d-flex align-items-center">
      <a
        class="nav-link dropdown-toggle arrow-none text-decoration-none"
        href="#"
        @click.prevent="toggleNotificationDropDown"
      >
        <span class="mdi mdi-bullhorn-outline noti-severity-icon"></span>
      </a>
    </div>

    <dropdown item-class="dropdown-lg" :show="showContainer">
      <!-- item-->
      <div class="dropdown-item noti-title">
        <h5 class="m-0">
          <span class="float-end" v-show="panelNotifications.length" />
          {{ $t('views.layouts.our_innovations') }}
        </h5>
      </div>

      <div class="slimScrollDiv">
        <!-- item-->
        <template v-if="panelNotifications.length">
          <div class="slimscroll">
            <a
              class="dropdown-item notify-item cursor-pointer"
              target="_blank"
              v-for="notification in panelNotifications"
              :key="notification.data.id"
              @click="notificationClick(notification.data)"
            >
              <div class="notify-icon bg-primary">
                <i class="mdi" :class="getIcon(notification.type)"></i>
              </div>
              <p
                v-if="displayContent($filters.truncate(notification.data.message, 200)).type === 'html'"
                class="notify-details"
                v-html="displayContent($filters.truncate(notification.data.message, 200)).content"
              ></p>
              <template v-else-if="displayContent($filters.truncate(notification.data.message, 200)).type === 'text'">
                <i18n-t class="notify-details" :keypath="$filters.truncate(notification.data.message, 200)" tag="p" />
              </template>
              <small class="text-muted notify-created-at">
                {{ $filters.humanReadable(notification.created_at) }}
              </small>
            </a>
          </div>
        </template>
        <div v-else class="dropdown-item notify-item">
          <p>{{ $t('views.layouts.no_new_notification') }}</p>
        </div>
      </div>
    </dropdown>
  </li>
</template>

<script>
import { storeToRefs } from 'pinia'

import { event } from 'vue-gtag'

import { useNotificationStore } from '@/stores/helpers/notification.js'

import { useAuthStore } from '@/stores/retailer/auth.js'
import { displayHTMLContent } from '@/utilities/helpers.js'

import { NOTIFICATION_SEVERITY_TYPES, NOTIFICATION_TYPES } from '@/constants/constants.js'

import Dropdown from '@/components/Dropdown.vue'

export default {
  components: {
    Dropdown
  },
  setup() {
    const authStore = useAuthStore()
    const notificationStore = useNotificationStore()
    const { filter_notifications_by_severities, user } = storeToRefs(authStore)

    return {
      filter_notifications_by_severities,
      user,
      authStore,
      notificationStore
    }
  },
  data() {
    return {
      showNotificationContainer: false
    }
  },
  beforeUnmount() {
    window.removeEventListener('click', this.close)
  },
  methods: {
    displayContent(message) {
      return displayHTMLContent(message)
    },
    toggleNotificationDropDown() {
      this.showNotificationContainer = !this.showNotificationContainer

      if (this.showNotificationContainer) {
        event('page_actions', {
          event_action: this.showNotificationContainer && 'notification_opened'
        })
      }
    },

    getNotificationType(type) {
      return type.split('\\').pop()
    },
    getIcon(type) {
      const notificationType = this.getNotificationType(type)
      if (notificationType === 'ExportReady') {
        return 'mdi-paperclip'
      } else {
        return 'mdi-bell'
      }
    },
    close(e) {
      if (!this.$el.contains(e.target)) {
        this.showNotificationContainer = false
      }
    },
    notificationClick(notificationData) {
      const notification = {
        message: notificationData.message,
        image: notificationData.image,
        kind: NOTIFICATION_TYPES[this.getNotificationTypeKeyByValue(notificationData.type)],
        type: NOTIFICATION_SEVERITY_TYPES.SUCCESS,
        is_dismissible: true,
        preventReadEvent: true
      }

      this.notificationStore.add(notification)
    },
    getNotificationTypeKeyByValue(value) {
      return Object.keys(NOTIFICATION_TYPES).find(key => NOTIFICATION_TYPES[key] === value)
    }
  },
  created() {
    this.authStore.filterNotificationsBySeverities()
    window.addEventListener('click', this.close)
  },
  computed: {
    showContainer() {
      return this.showNotificationContainer ? 'show' : ''
    },
    panelNotifications() {
      return this.filter_notifications_by_severities.filter(
        item => item.data.type === NOTIFICATION_SEVERITY_TYPES['SUCCESS']
      )
    }
  }
}
</script>
<style scoped>
.slimScrollDiv {
  height: auto;
  max-height: 300px;
  overflow-x: hidden;
}
</style>
